import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('dependentForm', 'relation');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dependent_registration',
  type: 'post',
  slug: [
    'assignments',
    {
      type: 'payload',
      selector: ['id'],
    },
    'relationships',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/dependentForm/relationship-req.js